import Cookies from 'js-cookie';

//全屏
export function fullScreen() {
	var el = document.documentElement;
	var rfs =
		el.requestFullScreen ||
		el.webkitRequestFullScreen ||
		el.mozRequestFullScreen ||
		el.msRequestFullScreen;

	//typeof rfs != "undefined" && rfs
	if (rfs) {
		rfs.call(el);
	} else if (typeof window.ActiveXObject !== 'undefined') {
		//for IE，这里其实就是模拟了按下键盘的F11，使浏览器全屏
		var wscript = new window.ActiveXObject('WScript.Shell');
		if (wscript != null) {
			wscript.SendKeys('{F11}');
		}
	}
}

//退出全屏
export function exitScreen() {
	var el = document;
	var cfs =
		el.cancelFullScreen ||
		el.webkitCancelFullScreen ||
		el.mozCancelFullScreen ||
		el.exitFullScreen;

	//typeof cfs != "undefined" && cfs
	if (cfs) {
		cfs.call(el);
	} else if (typeof window.ActiveXObject !== 'undefined') {
		//for IE，这里和fullScreen相同，模拟按下F11键退出全屏
		var wscript = new window.ActiveXObject('WScript.Shell');
		if (wscript != null) {
			wscript.SendKeys('{F11}');
		}
	}
}

export function getCurDayFirstTime() {
	const now = new Date();
	const formatTime =
		'' +
		now.getFullYear() +
		'-' +
		getFixLengthStringLeftAppendZero(now.getMonth() + 1, 2) +
		'-' +
		getFixLengthStringLeftAppendZero(now.getDate(), 2) +
		' 00:00:00';
	return formatTime;
}

export function getCurWeekFirstTime() {
	const now = new Date();
	const day = now.getDay();
	const date = now.getDate();
	switch (day) {
		case 0:
			now.setDate(date + 1);
			break;
		case 1:
			break;
		case 2:
			now.setDate(date - 1);
			break;
		case 3:
			now.setDate(date - 2);
			break;
		case 4:
			now.setDate(date - 3);
			break;
		case 5:
			now.setDate(date - 4);
			break;
		case 6:
			now.setDate(date - 5);
			break;
	}
	const formatTime =
		'' +
		now.getFullYear() +
		'-' +
		getFixLengthStringLeftAppendZero(now.getMonth() + 1, 2) +
		'-' +
		getFixLengthStringLeftAppendZero(now.getDate(), 2) +
		' 00:00:00';
	return formatTime;
}

export function getCurMonthFirstTime() {
	const now = new Date();
	const formatTime =
		'' +
		now.getFullYear() +
		'-' +
		getFixLengthStringLeftAppendZero(now.getMonth() + 1, 2) +
		'-01 00:00:00';
	return formatTime;
}

export function getCurYearFirstTime() {
	const now = new Date();
	const formatTime = '' + now.getFullYear() + '-01-01 00:00:00';
	return formatTime;
}

export function getCurDayStartTime() {
	const now = new Date();
	const formatTime =
		'' +
		now.getFullYear() +
		'-' +
		getFixLengthStringLeftAppendZero(now.getMonth() + 1, 2) +
		'-' +
		getFixLengthStringLeftAppendZero(now.getDate(), 2) +
		' 00:00:00';
	return formatTime;
}
// 获取下一个月
export function getLastMounth() {
	const now = new Date;
	let year = now.getFullYear();
	let month = now.getMonth() + 2;
	if (month >= 13) {
		month = 1;
		year++
	}
	const formatTime =
		'' +
		year +
		'-' +
		getFixLengthStringLeftAppendZero(month, 2) +
		'-01 00:00:00';
	return formatTime;
}
export function getCurDayEndTime() {
	const now = new Date();
	const formatTime =
		'' +
		now.getFullYear() +
		'-' +
		getFixLengthStringLeftAppendZero(now.getMonth() + 1, 2) +
		'-' +
		getFixLengthStringLeftAppendZero(now.getDate(), 2) +
		' 23:59:59';
	return formatTime;
}

export function getFixLengthStringLeftAppendZero(s, length) {
	if (typeof s == 'number') {
		s = s.toString();
	}
	while (s.length < length) {
		s = '0' + s;
	}
	return s;
}

export function translateObjectEmptyAttributeToNull(o) {
	for (let a in o) {
		if (typeof o[a] == 'string' && o[a] == '') {
			o[a] = null;
		}
	}

	return o;
}
// 减法运算
export function NumberSub(arg1, arg2) {
	var re1, re2, m;
	try {
		re1 = arg1.toString().split('.')[1].length;
	} catch (e) {
		re1 = 0;
	}
	try {
		re2 = arg2.toString().split('.')[1].length;
	} catch (e) {
		re2 = 0;
	}
	m = Math.pow(10, Math.max(re1, re2));
	// n = re1 >= re2 ? re1 : re2;
	// console.log(n);
	return ((arg1 * m - arg2 * m) / m).toFixed(2);
}
export function NumberAdd(arg1, arg2) {
	var r1, r2, m;
	try {
		r1 = arg1.toString().split('.')[1].length;
	} catch (e) {
		r1 = 0;
	}
	try {
		r2 = arg2.toString().split('.')[1].length;
	} catch (e) {
		r2 = 0;
	}
	m = Math.pow(10, Math.max(r1, r2));
	// n = r1 >= r2 ? r1 : r2;
	return ((arg1 * m + arg2 * m) / m).toFixed(2);
}
// 乘法运算
export function NumberMul(arg1, arg2) {
	var m = 0;
	var s1 = arg1.toString();
	var s2 = arg2.toString();
	try {
		m += s1.split('.')[1].length;
	} catch (e) {
		console.log('不是小数');
	}
	try {
		m += s2.split('.')[1].length;
	} catch (e) {
		console.log('不是小数');
	}

	return (
		(Number(s1.replace('.', '')) * Number(s2.replace('.', ''))) /
		Math.pow(10, m)
	);
}

const TokenKey = 'myToken';
const LoginUserKey = 'loginUser';
const LoginGardenKey = 'loginGarden';
export function getToken() {
	return Cookies.get(TokenKey);
}

export function setToken(token) {
	return Cookies.set(TokenKey, token);
}

export function removeToken() {
	return Cookies.remove(TokenKey);
}

export function setLoginUser(loginUser) {
	return Cookies.set(LoginUserKey, loginUser);
}

export function getLoginUser() {
	return Cookies.get(LoginUserKey);
}
export function removeLoginUser() {
	return Cookies.remove(LoginUserKey);
}

export function setLoginGarden(loginGarden) {
	return Cookies.set(LoginGardenKey, loginGarden);
}

export function getLoginGarden() {
	return Cookies.get(LoginGardenKey);
}

export function removeLoginGarden() {
	return Cookies.remove(LoginGardenKey);
}

export function clearCookie() {
	return Cookies.clear();
}

export function removeJSessionId() {
	return Cookies.remove('JSESSIONID');
}
// 级联选择器传入字符串
export function cascaderAfferentString(array) {
	var string = '';
	for (let i = 0; i < array.length; i++) {
		if (i == 0) {
			string += array[i];
		} else {
			let res = ',' + array[i];
			string += res;
		}
	}
	return string;
}
// 级联选择器传入数字
export function cascaderAfferentNumber(array) {
	var lastElement = array.slice(-1);
	var string = Number(lastElement);
	return string;
}

// 级联选择器接收转换成数组
export function cascaderAfferentArray(array) {
	let res = array.split(',');
	return res;
}

export function export_excel_file(export_data, list_name, fileType) {
	let link = document.createElement('a');
	let type = '';
	if (fileType == 'xls') {
		type = 'application/vnd.ms-excel;charset=utf-8';
	} else if (fileType == 'xlsx') {
		type = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
	}
	//    type就是blob的type,是MIME类型的，可以自己查看MIME类型都有哪些
	let blogw = new Blob([export_data], {
		type: type,
	});
	let objectUrl = window.URL.createObjectURL(blogw); //创建一个新的url对象
	link.href = objectUrl;
	let file_name = list_name;
	link.download = file_name; //  下载的时候自定义的文件名
	link.click();
	window.URL.revokeObjectURL(objectUrl); //为了更好地性能和内存使用状况，应该在适当的时候释放url.
}

// 金额数字转汉字
export function convertCurrency(n) {
	var fraction = ['角', '分'];
	var digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
	var unitOne = ['元', '万', '亿'];
	var unitTwo = ['', '拾', '佰', '仟'];

	var head = n < 0 ? '欠' : '';
	n = Math.abs(n); // 绝对值

	var s = '';
	for (var i = 0; i < fraction.length; i++) {
		var cf = Math.pow(10, i + 1); // 10的i+1次方
		s += (digit[Math.floor(cf * n) % 10] + fraction[i]).replace(/零./, '');
	}

	n = Math.floor(n); // 向下取整
	for (let i = 0; i < unitOne.length && n > 0; i++) {
		var p = '';
		for (var j = 0; j < unitTwo.length && n > 0; j++) {
			p = digit[n % 10] + unitTwo[j] + p;
			n = Math.floor(n / 10);
		}
		s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unitOne[i] + s;
	}

	if (s == '') {
		return '零元';
	}
	return head + s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零');
}

export function generatorUUID() {
	return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
		var r = (Math.random() * 16) | 0,
			v = c == 'x' ? r : (r & 0x3) | 0x8;
		return v.toString(16);
	});
}

export function isEmpty(data) {
	if (data == undefined || data == null || data == '') {
		return true;
	} else {
		return false;
	}
}
